<template>
  <div class="dialog-batch-add-wrapper">
    <el-dialog title="预生产设备" :visible="visible" @close="onDialogClose">
      <el-form label-position="top" ref="batchAddForm" :rules="batchAddRules" :model="batchAddForm">

        <el-form-item label="预生产数量（台）" prop="count">
          <el-input-number
            v-model="batchAddForm.count"
            controls-position="right"
            :min="1"
            :max="200"></el-input-number>
        </el-form-item>

        <el-form-item label="设备货架数量（个）" prop="goodsLength">
          <el-input-number
            v-model="batchAddForm.goodsLength"
            controls-position="right"
            :min="0"
            :max="100"></el-input-number>
        </el-form-item>

        <el-form-item label="预生产设备类型" prop="type">
          <el-select v-model="batchAddForm.type" placeholder="请选择设备类型">
            <el-option label="扭蛋机" value="gpm"></el-option>
            <el-option label="自动贩卖机" value="vm"></el-option>
            <el-option label="口红机" value="lpk"></el-option>
            <el-option label="脉冲" value="mc"></el-option>
            <el-option label="福袋机" value="fdj"></el-option>
            <el-option label="格子机" value="gzj"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item style="display: flex; justify-content: center;">
          <el-button type="danger" @click="onBatchAddSubmit">确定</el-button>
          <el-button @click="onBatchAddCancel">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { Loading } from 'element-ui'

import { mapActions } from 'vuex'

export default {
  name: 'DialogBatchAdd',
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      batchAddForm: {
        count: 10,
        goodsLength: 10,
        type: 'gpm'
      },
      batchAddRules: {
        count: [
          { required: true, message: '请输入预生产设备数量', trigger: 'blur' }
        ],
        goodsLength: [
          { required: true, message: '请输入预生产设备的货架数量', trigger: 'change' }
        ],
        type: [
          { required: true, message: '请选择设备类型', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    ...mapActions('factory', [
      'batchAddAdvRegistries'
    ]),

    onDialogClose () {
      this.$emit('update:visible', false)
    },
    onBatchAddSubmit () {
      this.$refs['batchAddForm'].validate(valid => {
        if (valid) {
          const fullLoading = Loading.service({
            fullscreen: true
          })

          // 发送批量添加请求
          this.batchAddAdvRegistries({
            count: parseInt(this.batchAddForm.count),
            goodsLength: parseInt(this.batchAddForm.goodsLength),
            type: this.batchAddForm.type
          }).then(res => {
            this.$message({
              type: 'success',
              message: '预生产设备成功'
            })

            this.$nextTick(() => {
              fullLoading.close()
            })
            this.$emit('data-change')
            this.$emit('update:visible', false)
            this.$refs['batchAddForm'].resetFields()
          }).catch(err => {
            console.log(err)

            this.$nextTick(() => {
              fullLoading.close()
            })
            this.$message({
              type: 'error',
              message: '预生产设备失败'
            })
          })
        } else {
          return false
        }
      })
    },
    onBatchAddCancel () {
      this.$emit('update:visible', false)
      this.$refs['batchAddForm'].resetFields()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/sass/base";
</style>



// WEBPACK FOOTER //
// src/components/factory/DialogBatchAddAdvRegistry.vue